import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FETCH_RESETPASS_LOG,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'resetpasswordlog' })
export default class ResetPasswordLog extends VuexModule {
  @Action
  FetchResetLog(username) {
    return Vue.axios({
      url: BASE_URL + FETCH_RESETPASS_LOG,
      data: username,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
